import core from '@/core/actions'
import dashboard from '@/dashboard/actions'
import learngroup from '@/learngroup/actions'
import learnpathsAssigned from '@/learnpaths-assigned/actions'
import mediaSummary from '@/learnpaths-media/actions'
import learnpaths from '@/learnpaths/actions'
import lecture from '@/lecture/actions'
import quiz from '@/quiz/actions'
import scorm from '@/scorm/actions'
import user from '@/user/actions'

export default {
  core,
  dashboard,
  learngroup,
  learnpaths,
  learnpathsAssigned,
  lecture,
  mediaSummary,
  quiz,
  scorm,
  /**
   * @deprecated
   */
  user,
}
